import { getAllDataForEditingApi } from "@/features/player/api/download";
import { useEffect, useMemo, useState } from "react";
import { AllSubscriptionData } from "@/features/player/api/types";
import { langToLangApi } from "@/shared/const/locale";
import { SubtitleItem } from "@/shared/types/player";

interface UseDataProps {
    mediaId: string;
    lang: string;
}

export const useData = ({ mediaId, lang }: UseDataProps) => {
    const [data, setData] = useState<AllSubscriptionData[]>();

    useEffect(() => {
        const getData = async () => {
            try {
                const data = await getAllDataForEditingApi({
                    mediaId,
                    lang: langToLangApi[lang],
                });
                setData(data);
            } catch (error) {
                console.log("load data error", error);
            }
        };
        if (lang) {
            getData();
        }
    }, [mediaId, lang]);

    const subtitles = useMemo(() => {
        if (data) {
            const subtitles: SubtitleItem[] = data?.reduce(
                (acc: SubtitleItem[], item) => {
                    const prev = parseInt(item.prev_mp3_length_aggr);
                    const translations: SubtitleItem[] = item.translations.map(
                        (trans) => {
                            return {
                                start: trans.start + prev,
                                end: trans.start + trans.length + prev,
                                length: trans.length,
                                caption: trans.captions,
                                id: trans.id,
                            };
                        },
                    );
                    return [...acc, ...translations];
                },
                [],
            );
            return subtitles;
        }
        return [];
    }, [data]);

    return { data, audioUrl: data?.[0].orig_mp3 || "", subtitles };
};
